/**
 * 閉じたときに、フォーカスを開いたボタンへ戻すかどうか(メニュー・ポップオーバー・ダイアログ共通)。
 * Radix は閉じるたびにボタンへフォーカスを戻すが、プログラムによるフォーカスは、直前の操作次第で
 * :focus-visible になり、太いフォーカスリングが出たり出なかったりする(ユーザー指摘 2026-10-07)。
 * そこで、直前の操作がマウス・タッチのときは戻さない。キーボードのときは戻す(キーボード操作を保つ)。
 */
let lastInputWasKeyboard = false;
let listening = false;

function listen() {
  if (listening || typeof document === "undefined") return;
  listening = true;
  document.addEventListener("keydown", () => (lastInputWasKeyboard = true), true);
  document.addEventListener("pointerdown", () => (lastInputWasKeyboard = false), true);
}
listen();

/** Radix の `onCloseAutoFocus` に渡す。マウス・タッチで閉じたときは、フォーカスを戻さない。 */
export function skipRefocusAfterPointer(event: Event) {
  if (!lastInputWasKeyboard) event.preventDefault();
}
